import { useMemo } from 'react';

import { Box, Stack } from '@mui/material';
import { RequirementItem } from './RequirementItem';
import { JobOpeningCrucialRequirementCategory } from '@types';

export const NONE_OPTION_VALUE = 'none';
export const NONE_OPTION_LABEL = 'None of the above';

interface IRequirement {
  name: string;
  description: string | null;
  category: JobOpeningCrucialRequirementCategory;
}

interface IRequirementsListProps {
  requirements: IRequirement[];
  selectedRequirements: Record<string, boolean | null>;
  handleChange: (
    category: JobOpeningCrucialRequirementCategory,
    name: string,
    value: boolean,
  ) => void;
}

export const RequirementsList: React.FC<IRequirementsListProps> = ({
  requirements,
  selectedRequirements,
  handleChange,
}) => {
  const { withDescription, withoutDescription } = useMemo(() => {
    const withDesc: IRequirement[] = [];
    const withoutDesc: IRequirement[] = [];

    for (const req of requirements) {
      (req.description ? withDesc : withoutDesc).push(req);
    }

    return { withDescription: withDesc, withoutDescription: withoutDesc };
  }, [requirements]);

  if (!requirements.length) return null;

  const firstCategory = requirements[0].category;

  return (
    <>
      {withoutDescription.length > 0 && (
        <Stack direction="column" gap={1}>
          <Box display="flex" gap={1} flexWrap="wrap">
            {withoutDescription.map((req) => (
              <RequirementItem
                key={req.name}
                category={req.category}
                label={req.name}
                name={req.name}
                description=""
                selectedValue={selectedRequirements[req.name]}
                handleChange={handleChange}
              />
            ))}
          </Box>
          <Box display="flex">
            <RequirementItem
              category={firstCategory}
              label={NONE_OPTION_LABEL}
              name={NONE_OPTION_VALUE}
              selectedValue={selectedRequirements[NONE_OPTION_VALUE]}
              handleChange={handleChange}
            />
          </Box>
        </Stack>
      )}
      {withDescription.length > 0 && (
        <Box display="flex" flexDirection="column" gap={4}>
          {withDescription.map((req) => (
            <RequirementItem
              key={req.name}
              category={req.category}
              label={req.name}
              name={req.name}
              description={req.description}
              selectedValue={selectedRequirements[req.name]}
              handleChange={handleChange}
            />
          ))}
        </Box>
      )}
    </>
  );
};
